import { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
  fontFamily:
    // eslint-disable-next-line max-len -- many fallbacks
    '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontWeightBold: 600,
  h1: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '2.4rem',
    lineHeight: 1.4,
  },
  h2: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '2.3rem',
    lineHeight: 1.4,
  },
  h3: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '2.1rem',
    lineHeight: 1.4,
  },
  h4: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.9rem',
    lineHeight: 1.4,
  },
  h5: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.7rem',
    lineHeight: 1.5,
  },
  h6: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  subtitle1: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 500,
    fontSize: '1.7rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  body1: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 400,
    fontSize: '1.7rem',
    lineHeight: 1.5,
  },
  body2: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  button: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  buttonSmall: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 500,
    fontSize: '1.3rem',
    lineHeight: 1.5,
  },
  buttonLarge: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  overline: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: 1.5,
    textTransform: 'initial',
  },
  caption: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: 1.5,
  },
};
